// extracted by mini-css-extract-plugin
module.exports = {"root":"RangeSlider_root__2-ijB","activeHandle":"RangeSlider_activeHandle__1Fytn"};